define(function(require, exports, module) {
    'use strict';

    var utils = require('utils');
    var _ = require('underscore');
    var ConfigurationClass = require('class/configuration.class');
    var Class = require('Class');
    var deviceCommon = require('util/device.common.util');

    module.exports = Class.create(ConfigurationClass, {
        initialize: function() {
            ConfigurationClass.prototype.initialize.apply(this, arguments);
            this.load(Playtech.Variables);
        },

        _getGamesConfiguration: function(gamesConfiguration) {
            const { os, browserName, formFactor, isOtherOs, isOtherBrowser } = deviceCommon;

            var handleOtherOs = game => game.oses.includes('other') && isOtherOs;

            var handleOtherBrowser = game => game.browsers.includes('other') && isOtherBrowser;

            var filterByOs = game => Boolean(game.oses) && (game.oses.includes(os) || handleOtherOs(game));

            var filterByBrowser = game => Boolean(game.browsers) && (game.browsers.includes(browserName)
                || handleOtherBrowser(game));

            var filterByFormFactor = game => Boolean(game.formFactors) && game.formFactors.includes(formFactor);

            return _.chain(gamesConfiguration)
                .filter(game => filterByOs(game) && filterByBrowser(game) && filterByFormFactor(game))
                .reduce((memo, item) => {
                    memo[item.gameCode] = item;

                    return memo;
                }, {})
                .value();
        },

        parse: function(originalConfig) {
            var config = utils.deepClone(originalConfig) || {};

            if (config.animationConfig) {
                config.animationConfig = config.animationConfig[deviceCommon.formFactor];
                if (deviceCommon.isCrawlerBot) {
                    config.animationConfig.animationEnabled = false;
                }
            }

            _.each(config.gamesFeeds, function(feed) {
                if (!feed.translationKeyPrefixMob) {
                    feed.translationKeyPrefixMob = 'playtech.mobile.games-info.' + feed.name.toLowerCase();
                }
            });

            if (!_.isEmpty(config.sessionSubscriptionTypes) && !_.isArray(config.sessionSubscriptionTypes)) {
                config.sessionSubscriptionTypes = config.sessionSubscriptionTypes.replace(/\s/g, '').split(',');
            }

            if (config.gamesConfiguration) {
                config.gamesConfiguration = this._getGamesConfiguration(config.gamesConfiguration);
            }

            _.each(['ssoPasDomain', 'ssoPasJsURLs', 'openApiDomain', 'ssoPasExternalJsUrl'], (endpoint) => {
                if (config[endpoint]) {
                    config[endpoint] = this.parseSuperDomainEndpoint(config[endpoint]);
                }
            });

            config.requestStamp = Playtech.Variables.modifiedDate || Date.now();

            if (!config.isFormsLoaded && config.forms) {
                delete config.forms;
            }

            return config;
        },

        load: function(config) {
            var parsedConfig = this.parse(config);

            //@TODO for backward compatibility. Remove ASAP
            utils.deepExtend(Playtech.Variables, parsedConfig);

            ConfigurationClass.prototype.load.call(this, parsedConfig);
        },

        parseSuperDomainEndpoint: function(endpoint = '') {
            const superDomainRegex = /\[superdomain]/;

            return superDomainRegex.test(endpoint)
                ? endpoint.replace(superDomainRegex, window.location.hostname.split('.').slice(1).join('.'))
                : endpoint;
        }
    });
});
